var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.hide
    ? _c("div", { staticClass: "landing-image", style: _vm.customStyles }, [
        _vm.overlayText
          ? _c("div", { staticClass: "landing-image__overlay" }, [
              _vm.overlayText.title
                ? _c(
                    "h1",
                    {
                      staticClass: "landing-image__title",
                      attrs: { "data-typo-type": "title" },
                    },
                    [_vm._v(" " + _vm._s(_vm.overlayText.title) + " ")]
                  )
                : _vm._e(),
              _vm.overlayText.subtitle
                ? _c("h2", {
                    staticClass: "landing-image__subtitle",
                    attrs: { "data-typo-type": "subtitle" },
                    domProps: { innerHTML: _vm._s(_vm.overlayText.subtitle) },
                  })
                : _vm._e(),
            ])
          : _vm._e(),
        _c("img", { attrs: { src: _vm.img, alt: "" } }),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }